import { Injectable } from '@angular/core';
import { CacheTypes } from './cache-headers';
import { CachingStorage, CachedItem } from './cache.service';

@Injectable({
  providedIn: 'root'
})
export class InMemoryCachingStorageService implements CachingStorage {

  cache: { [key: string]: CachedItem } = {};

  get name() : string
  {
    return CacheTypes.InMemory;
  }

  get(key: string): CachedItem {
    return this.cache[key];
  }

  put(key: string, value: CachedItem): void {
    this.cache[key] = value;
  }

  delete(key: string): void {
    delete this.cache[key];
  }

  getKeys(): string[] {
    return Object.keys(this.cache);
  }

  clear(): void {
    const keys = this.getKeys();
    for (const key of keys) {
      this.delete(key);
    }
  }

}
